"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get down () {
        return down;
    },
    get up () {
        return up;
    }
});
const _common = require("@nestjs/common");
const _globals = require("~/utils/globals");
const logger = new _common.Logger('nc_036_rename_project_and_base');
const up = async (knex)=>{
    logger.log('Renaming base table');
    if (await knex.schema.hasTable(_globals.MetaTableOldV2.BASES)) await knex.schema.renameTable(_globals.MetaTableOldV2.BASES, _globals.MetaTable.SOURCES_OLD);
    logger.log('Renaming `base_id` column to `source_id`');
    if (await knex.schema.hasColumn(_globals.MetaTable.MODELS, 'base_id')) await knex.schema.alterTable(_globals.MetaTable.MODELS, (table)=>{
        table.renameColumn('base_id', 'source_id');
    });
    logger.log(`Renaming 'base_id' column to 'source_id' in '${_globals.MetaTable.COLUMNS}' table`);
    if (await knex.schema.hasColumn(_globals.MetaTable.COLUMNS, 'base_id')) await knex.schema.alterTable(_globals.MetaTable.COLUMNS, (table)=>{
        table.renameColumn('base_id', 'source_id');
    });
    logger.log(`Renaming 'base_id' column to 'source_id' in '${_globals.MetaTable.VIEWS}' table`);
    if (await knex.schema.hasColumn(_globals.MetaTable.VIEWS, 'base_id')) await knex.schema.alterTable(_globals.MetaTable.VIEWS, (table)=>{
        table.renameColumn('base_id', 'source_id');
    });
    logger.log(`Renaming 'base_id' column to 'source_id' in '${_globals.MetaTable.GALLERY_VIEW}' table`);
    if (await knex.schema.hasColumn(_globals.MetaTable.GALLERY_VIEW, 'base_id')) await knex.schema.alterTable(_globals.MetaTable.GALLERY_VIEW, (table)=>{
        table.renameColumn('base_id', 'source_id');
    });
    logger.log(`Renaming 'base_id' column to 'source_id' in '${_globals.MetaTable.GRID_VIEW}' table`);
    if (await knex.schema.hasColumn(_globals.MetaTable.GRID_VIEW, 'base_id')) await knex.schema.alterTable(_globals.MetaTable.GRID_VIEW, (table)=>{
        table.renameColumn('base_id', 'source_id');
    });
    logger.log(`Renaming 'base_id' column to 'source_id' in '${_globals.MetaTable.KANBAN_VIEW}' table`);
    if (await knex.schema.hasColumn(_globals.MetaTable.KANBAN_VIEW, 'base_id')) await knex.schema.alterTable(_globals.MetaTable.KANBAN_VIEW, (table)=>{
        table.renameColumn('base_id', 'source_id');
    });
    logger.log(`Renaming 'base_id' column to 'source_id' in '${_globals.MetaTable.FORM_VIEW}' table`);
    if (await knex.schema.hasColumn(_globals.MetaTable.FORM_VIEW, 'base_id')) await knex.schema.alterTable(_globals.MetaTable.FORM_VIEW, (table)=>{
        table.renameColumn('base_id', 'source_id');
    });
    logger.log(`Renaming 'base_id' column to 'source_id' in '${_globals.MetaTable.MAP_VIEW}' table`);
    if (await knex.schema.hasColumn(_globals.MetaTable.MAP_VIEW, 'base_id')) await knex.schema.alterTable(_globals.MetaTable.MAP_VIEW, (table)=>{
        table.renameColumn('base_id', 'source_id');
    });
    logger.log(`Renaming 'base_id' column to 'source_id' in '${_globals.MetaTable.GALLERY_VIEW_COLUMNS}' table`);
    if (await knex.schema.hasColumn(_globals.MetaTable.GALLERY_VIEW_COLUMNS, 'base_id')) await knex.schema.alterTable(_globals.MetaTable.GALLERY_VIEW_COLUMNS, (table)=>{
        table.renameColumn('base_id', 'source_id');
    });
    logger.log(`Renaming 'base_id' column to 'source_id' in '${_globals.MetaTable.GRID_VIEW_COLUMNS}' table`);
    if (await knex.schema.hasColumn(_globals.MetaTable.GRID_VIEW_COLUMNS, 'base_id')) await knex.schema.alterTable(_globals.MetaTable.GRID_VIEW_COLUMNS, (table)=>{
        table.renameColumn('base_id', 'source_id');
    });
    logger.log(`Renaming 'base_id' column to 'source_id' in '${_globals.MetaTable.KANBAN_VIEW_COLUMNS}' table`);
    if (await knex.schema.hasColumn(_globals.MetaTable.KANBAN_VIEW_COLUMNS, 'base_id')) await knex.schema.alterTable(_globals.MetaTable.KANBAN_VIEW_COLUMNS, (table)=>{
        table.renameColumn('base_id', 'source_id');
    });
    logger.log(`Renaming 'base_id' column to 'source_id' in '${_globals.MetaTable.FORM_VIEW_COLUMNS}' table`);
    if (await knex.schema.hasColumn(_globals.MetaTable.FORM_VIEW_COLUMNS, 'base_id')) await knex.schema.alterTable(_globals.MetaTable.FORM_VIEW_COLUMNS, (table)=>{
        table.renameColumn('base_id', 'source_id');
    });
    logger.log(`Renaming 'base_id' column to 'source_id' in '${_globals.MetaTable.SORT}' table`);
    if (await knex.schema.hasColumn(_globals.MetaTable.SORT, 'base_id')) await knex.schema.alterTable(_globals.MetaTable.SORT, (table)=>{
        table.renameColumn('base_id', 'source_id');
    });
    logger.log(`Renaming 'base_id' column to 'source_id' in '${_globals.MetaTable.FILTER_EXP}' table`);
    if (await knex.schema.hasColumn(_globals.MetaTable.FILTER_EXP, 'base_id')) await knex.schema.alterTable(_globals.MetaTable.FILTER_EXP, (table)=>{
        table.renameColumn('base_id', 'source_id');
    });
    logger.log(`Renaming 'base_id' column to 'source_id' in '${_globals.MetaTable.HOOKS}' table`);
    if (await knex.schema.hasColumn(_globals.MetaTable.HOOKS, 'base_id')) await knex.schema.alterTable(_globals.MetaTable.HOOKS, (table)=>{
        table.renameColumn('base_id', 'source_id');
    });
    logger.log(`Renaming 'base_id' column to 'source_id' in '${_globals.MetaTable.HOOK_LOGS}' table`);
    if (await knex.schema.hasColumn(_globals.MetaTable.HOOK_LOGS, 'base_id')) await knex.schema.alterTable(_globals.MetaTable.HOOK_LOGS, (table)=>{
        table.renameColumn('base_id', 'source_id');
    });
    logger.log(`Renaming 'base_id' column to 'source_id' in '${_globals.MetaTable.MODEL_ROLE_VISIBILITY}' table`);
    if (await knex.schema.hasColumn(_globals.MetaTable.MODEL_ROLE_VISIBILITY, 'base_id')) await knex.schema.alterTable(_globals.MetaTable.MODEL_ROLE_VISIBILITY, (table)=>{
        table.renameColumn('base_id', 'source_id');
    });
    logger.log(`Renaming 'base_id' column to 'source_id' in '${_globals.MetaTable.AUDIT}' table`);
    if (await knex.schema.hasColumn(_globals.MetaTable.AUDIT, 'base_id')) await knex.schema.alterTable(_globals.MetaTable.AUDIT, (table)=>{
        table.renameColumn('base_id', 'source_id');
    });
    logger.log(`Renaming 'base_id' column to 'source_id' in '${_globals.MetaTable.SYNC_LOGS}' table`);
    if (await knex.schema.hasColumn(_globals.MetaTable.SYNC_SOURCE, 'base_id')) await knex.schema.alterTable(_globals.MetaTable.SYNC_SOURCE, (table)=>{
        table.renameColumn('base_id', 'source_id');
    });
    logger.log(`Renaming 'fk_sync_base_id' column to 'fk_sync_source_id' in '${_globals.MetaTable.SYNC_LOGS}' table`);
    if (await knex.schema.hasColumn(_globals.MetaTable.SYNC_LOGS, 'fk_sync_base_id')) await knex.schema.alterTable(_globals.MetaTable.SYNC_LOGS, (table)=>{
        table.renameColumn('fk_sync_base_id', 'fk_sync_source_id');
    });
    logger.log('Renaming project table');
    if (await knex.schema.hasTable(_globals.MetaTableOldV2.PROJECT)) await knex.schema.renameTable(_globals.MetaTableOldV2.PROJECT, _globals.MetaTable.PROJECT);
    logger.log(`Renaming 'project_id' column to 'base_id' in '${_globals.MetaTable.MODELS}' table`);
    if (await knex.schema.hasColumn(_globals.MetaTable.MODELS, 'project_id')) await knex.schema.alterTable(_globals.MetaTable.MODELS, (table)=>{
        table.renameColumn('project_id', 'base_id');
    });
    logger.log(`Renaming 'project_id' column to 'base_id' in '${_globals.MetaTable.COLUMNS}' table`);
    if (await knex.schema.hasColumn(_globals.MetaTable.COLUMNS, 'project_id')) await knex.schema.alterTable(_globals.MetaTable.COLUMNS, (table)=>{
        table.renameColumn('project_id', 'base_id');
    });
    logger.log(`Renaming 'project_id' column to 'base_id' in '${_globals.MetaTable.VIEWS}' table`);
    if (await knex.schema.hasColumn(_globals.MetaTable.VIEWS, 'project_id')) await knex.schema.alterTable(_globals.MetaTable.VIEWS, (table)=>{
        table.renameColumn('project_id', 'base_id');
    });
    logger.log(`Renaming 'project_id' column to 'base_id' in '${_globals.MetaTable.GALLERY_VIEW}' table`);
    if (await knex.schema.hasColumn(_globals.MetaTable.GALLERY_VIEW, 'project_id')) await knex.schema.alterTable(_globals.MetaTable.GALLERY_VIEW, (table)=>{
        table.renameColumn('project_id', 'base_id');
    });
    logger.log(`Renaming 'project_id' column to 'base_id' in '${_globals.MetaTable.GRID_VIEW}' table`);
    if (await knex.schema.hasColumn(_globals.MetaTable.GRID_VIEW, 'project_id')) await knex.schema.alterTable(_globals.MetaTable.GRID_VIEW, (table)=>{
        table.renameColumn('project_id', 'base_id');
    });
    logger.log(`Renaming 'project_id' column to 'base_id' in '${_globals.MetaTable.KANBAN_VIEW}' table`);
    if (await knex.schema.hasColumn(_globals.MetaTable.KANBAN_VIEW, 'project_id')) await knex.schema.alterTable(_globals.MetaTable.KANBAN_VIEW, (table)=>{
        table.renameColumn('project_id', 'base_id');
    });
    logger.log(`Renaming 'project_id' column to 'base_id' in '${_globals.MetaTable.FORM_VIEW}' table`);
    if (await knex.schema.hasColumn(_globals.MetaTable.FORM_VIEW, 'project_id')) await knex.schema.alterTable(_globals.MetaTable.FORM_VIEW, (table)=>{
        table.renameColumn('project_id', 'base_id');
    });
    logger.log(`Renaming 'project_id' column to 'base_id' in '${_globals.MetaTable.MAP_VIEW}' table`);
    if (await knex.schema.hasColumn(_globals.MetaTable.MAP_VIEW, 'project_id')) await knex.schema.alterTable(_globals.MetaTable.MAP_VIEW, (table)=>{
        table.renameColumn('project_id', 'base_id');
    });
    logger.log(`Renaming 'project_id' column to 'base_id' in '${_globals.MetaTable.GALLERY_VIEW_COLUMNS}' table`);
    if (await knex.schema.hasColumn(_globals.MetaTable.GALLERY_VIEW_COLUMNS, 'project_id')) await knex.schema.alterTable(_globals.MetaTable.GALLERY_VIEW_COLUMNS, (table)=>{
        table.renameColumn('project_id', 'base_id');
    });
    logger.log(`Renaming 'project_id' column to 'base_id' in '${_globals.MetaTable.GRID_VIEW_COLUMNS}' table`);
    if (await knex.schema.hasColumn(_globals.MetaTable.GRID_VIEW_COLUMNS, 'project_id')) await knex.schema.alterTable(_globals.MetaTable.GRID_VIEW_COLUMNS, (table)=>{
        table.renameColumn('project_id', 'base_id');
    });
    logger.log(`Renaming 'project_id' column to 'base_id' in '${_globals.MetaTable.KANBAN_VIEW_COLUMNS}' table`);
    if (await knex.schema.hasColumn(_globals.MetaTable.KANBAN_VIEW_COLUMNS, 'project_id')) await knex.schema.alterTable(_globals.MetaTable.KANBAN_VIEW_COLUMNS, (table)=>{
        table.renameColumn('project_id', 'base_id');
    });
    logger.log(`Renaming 'project_id' column to 'base_id' in '${_globals.MetaTable.FORM_VIEW_COLUMNS}' table`);
    if (await knex.schema.hasColumn(_globals.MetaTable.FORM_VIEW_COLUMNS, 'project_id')) await knex.schema.alterTable(_globals.MetaTable.FORM_VIEW_COLUMNS, (table)=>{
        table.renameColumn('project_id', 'base_id');
    });
    logger.log(`Renaming 'project_id' column to 'base_id' in '${_globals.MetaTable.SORT}' table`);
    if (await knex.schema.hasColumn(_globals.MetaTable.SORT, 'project_id')) await knex.schema.alterTable(_globals.MetaTable.SORT, (table)=>{
        table.renameColumn('project_id', 'base_id');
    });
    logger.log(`Renaming 'project_id' column to 'base_id' in '${_globals.MetaTable.FILTER_EXP}' table`);
    if (await knex.schema.hasColumn(_globals.MetaTable.FILTER_EXP, 'project_id')) await knex.schema.alterTable(_globals.MetaTable.FILTER_EXP, (table)=>{
        table.renameColumn('project_id', 'base_id');
    });
    logger.log(`Renaming 'project_id' column to 'base_id' in '${_globals.MetaTable.HOOKS}' table`);
    if (await knex.schema.hasColumn(_globals.MetaTable.HOOKS, 'project_id')) await knex.schema.alterTable(_globals.MetaTable.HOOKS, (table)=>{
        table.renameColumn('project_id', 'base_id');
    });
    logger.log(`Renaming 'project_id' column to 'base_id' in '${_globals.MetaTable.HOOK_LOGS}' table`);
    if (await knex.schema.hasColumn(_globals.MetaTable.HOOK_LOGS, 'project_id')) await knex.schema.alterTable(_globals.MetaTable.HOOK_LOGS, (table)=>{
        table.renameColumn('project_id', 'base_id');
    });
    logger.log(`Renaming 'project_id' column to 'base_id' in '${_globals.MetaTable.MODEL_ROLE_VISIBILITY}' table`);
    if (await knex.schema.hasColumn(_globals.MetaTable.MODEL_ROLE_VISIBILITY, 'project_id')) await knex.schema.alterTable(_globals.MetaTable.MODEL_ROLE_VISIBILITY, (table)=>{
        table.renameColumn('project_id', 'base_id');
    });
    logger.log(`Renaming 'project_id' column to 'base_id' in '${_globals.MetaTable.AUDIT}' table`);
    if (await knex.schema.hasColumn(_globals.MetaTable.AUDIT, 'project_id')) await knex.schema.alterTable(_globals.MetaTable.AUDIT, (table)=>{
        table.renameColumn('project_id', 'base_id');
    });
    logger.log(`Renaming 'project_id' column to 'base_id' in '${_globals.MetaTable.SYNC_LOGS}' table`);
    if (await knex.schema.hasColumn(_globals.MetaTable.SYNC_LOGS, 'project_id')) await knex.schema.alterTable(_globals.MetaTable.SYNC_SOURCE, (table)=>{
        table.renameColumn('project_id', 'base_id');
    });
    logger.log(`Renaming 'project_id' column to 'base_id' in '${_globals.MetaTable.SYNC_LOGS}' table`);
    if (await knex.schema.hasColumn(_globals.MetaTable.SYNC_LOGS, 'project_id')) await knex.schema.alterTable(_globals.MetaTable.SYNC_LOGS, (table)=>{
        table.renameColumn('project_id', 'base_id');
    });
    logger.log(`Renaming Project Users table`);
    if (await knex.schema.hasTable(_globals.MetaTableOldV2.PROJECT_USERS)) await knex.schema.renameTable(_globals.MetaTableOldV2.PROJECT_USERS, _globals.MetaTable.PROJECT_USERS);
    logger.log(`Renaming 'project_id' column to 'base_id' in '${_globals.MetaTable.PROJECT_USERS}' table`);
    if (await knex.schema.hasColumn(_globals.MetaTable.PROJECT_USERS, 'project_id')) await knex.schema.alterTable(_globals.MetaTable.PROJECT_USERS, (table)=>{
        table.renameColumn('project_id', 'base_id');
    });
    logger.log(`Renaming 'project_id' column to 'base_id' in '${_globals.MetaTable.SOURCES_OLD}' table`);
    if (await knex.schema.hasColumn(_globals.MetaTable.SOURCES_OLD, 'project_id')) await knex.schema.alterTable(_globals.MetaTable.SOURCES_OLD, (table)=>{
        table.renameColumn('project_id', 'base_id');
    });
    logger.log(`Renaming 'project_id' column to 'base_id' in '${_globals.MetaTable.STORE}' table`);
    if (await knex.schema.hasColumn(_globals.MetaTable.STORE, 'project_id')) await knex.schema.alterTable(_globals.MetaTable.STORE, (table)=>{
        table.renameColumn('project_id', 'base_id');
    });
    logger.log(`Renaming 'project_id' column to 'base_id' in '${_globals.MetaTable.API_TOKENS}' table`);
    if (await knex.schema.hasColumn(_globals.MetaTable.API_TOKENS, 'project_id')) await knex.schema.alterTable(_globals.MetaTable.API_TOKENS, (table)=>{
        table.renameColumn('project_id', 'base_id');
    });
};
const down = async (_knex)=>{};
